import actionTypes from '../actionTypes';

export const moveStep = (step) => ({
  type: actionTypes.CREATE_MOVE_STEP,
  step,
});

export const assignAttribute = (field, attribute) => ({
  type: actionTypes.CREATE_ASSIGN_ATTRIBUTE,
  field,
  attribute,
});

export const resetAttribute = () => ({
  type: actionTypes.CREATE_RESET_ATTRIBUTE,
});



// WEBPACK FOOTER //
// src/redux/actions/create.js